import { Divider, Icon, ICONS } from '@creditsights/styleguide-web';
import classNames from 'classnames/bind';
import React from 'react';
import { ArticleLockType } from '../../../../../models';
import { SearchDocumentsDto } from '../../../../../services/dtos/securities/searchDocuments.dto';

import { GroupedTableRowRendererProps } from '../../GroupedTableRow/GroupedTableRow.types';
import styles from './LockedDocumentRenderer.module.scss';

const cx = classNames.bind(styles);

const getLockType = (data: SearchDocumentsDto) =>
  data.is_associated_report_public ? ArticleLockType.Subscribe : ArticleLockType.RequestAccess;

const LockedDocumentRenderer = ({
  data,
}: GroupedTableRowRendererProps<SearchDocumentsDto>): React.ReactElement | null => {
  if (data.can_access) {
    return null;
  }

  const lockType = getLockType(data);
  return (
    <div className={cx('body')}>
      <span className={cx('label-container')}>
        <Icon name={ICONS.LockOutline} />
        <Divider vertical className={cx('divider')} />
        <span className={cx('label')} data-testid="label-text">
          {lockType}
        </span>
      </span>
    </div>
  );
};

export default LockedDocumentRenderer;
